import { customColors } from '@apollo/orbit';
import classnames from 'classnames';
import { GraphQLEnumValue } from 'graphql';
import React from 'react';

import { Tooltip } from 'src/components/common/tooltip/Tooltip';
import { useRouteParams } from 'src/hooks/useRouteParams';

import { fieldRouteConfig } from '../../../../../routes';

interface EnumValueCoordinateSignatureProps {
  enumValue: GraphQLEnumValue;
  isRootType: boolean;
}

export const EnumValueCoordinateSignature = ({
  enumValue,
  isRootType,
}: EnumValueCoordinateSignatureProps) => {
  const { typeName } = useRouteParams(fieldRouteConfig);

  return (
    <div>
      <div className="font-mono" style={{ color: customColors.code.a }}>
        {isRootType ? 'root' : 'enum'} {typeName} {' {'}
      </div>
      <div className="ml-3">
        <Tooltip
          disabled={!enumValue.deprecationReason}
          label={enumValue.deprecationReason}
          placement="top-start"
        >
          <span
            className={classnames('font-mono text-primary', {
              'line-through': enumValue.isDeprecated,
            })}
          >
            {enumValue.name}
          </span>
        </Tooltip>
      </div>
      <div style={{ color: customColors.code.a }}>{' }'}</div>
    </div>
  );
};
